import Button from "../../components/Button";
import Icon from "../../components/Icon";
import ImageWrapper from "../../components/ImageWrapper";
import implanti from "../../assets/img/impl3.jpg";
import implantology2 from "../../assets/img/dentalimplant.jpg";
import ContactForm from "../../sections/ContactForm";
import Doctor from "../../sections/Doctor";

export default function Implantology() {
  return (
    <>
      <div className="bg-implantology w-full h-[70vh] bg-cover bg-center flex items-center justify-center">
        <h1 className="text-4xl lg:text-5xl text-white text-center font-extrabold">
          Имплантология
        </h1>
      </div>
      <div className="page__width my-32 gap-2 flex flex-col items-center justify-center">
        <div className="flex items-center gap-1">
          <div className="bg-brand w-16 rounded-full h-[6px]"></div>
          <div className="bg-brand w-8 rounded-full h-[6px]"></div>
          <div className="bg-brand w-2 rounded-full h-[6px]"></div>
        </div>
        <h2 className="text-3xl font-extrabold text-center text-heading">
          Усмивка за Цял Живот
        </h2>
        <p className="text-body text-lg text-center">
        Денталните импланти са съвременна технология за възстановяване на липсващи зъби. Имплантът представлява титаниева структура, която се фиксира в костта, където има липсващ зъб и играе ролята на корен на бъдещия нов зъб. Лечението с импланти дава възможност за възстановяване на обеззъбен участък без изпиляване на съседни здрави зъби. 
        </p>
      </div>

      <div className="page__width mt-20 flex flex-col-reverse justify-between lg:flex-row-reverse items-center gap-8">
        <div className="w-full lg:w-1/2">
          <ImageWrapper src={implantology2} className="w-full aspect-square rounded-lg" />
        </div>
        <div className="w-full lg:w-2/5 flex gap-2 flex-col items-start">
          <div className="flex items-center gap-1">
            <div className="bg-brand w-16 rounded-full h-[6px]"></div>
            <div className="bg-brand w-8 rounded-full h-[6px]"></div>
            <div className="bg-brand w-2 rounded-full h-[6px]"></div>
          </div>
          <h2 className="text-3xl font-extrabold text-heading">
            Вашата Усмивка, Нашият Приоритет
          </h2>
          <p className="text-base text-body font-normal">
          Една от най-важните им функции е, че спомагат за запазването на челюстната кост, както и на останалите естествени зъби.Правилната орална хигиена и грижи от страна на пациента прави имплантологичното лечение трайно, сигурно и ефикасно. Зъбните импланти са изработени от титан, който е напълно биосъвместим материал и не предизвиква алергични реакции.
          </p>
          <Button type="cta-border" href="/contact">
            Запазете час още сега!
          </Button>
        </div>
      </div>

      <div className="page__width mt-20 flex flex-col-reverse justify-between lg:flex-row items-center gap-8">
        <div className="w-full lg:w-1/2">
          <ImageWrapper src={implanti} className="w-full aspect-square" />
        </div>
        <div className="w-full lg:w-2/5 flex gap-2 flex-col items-start">
          <div className="flex items-center gap-1">
            <div className="bg-brand w-16 rounded-full h-[6px]"></div>
            <div className="bg-brand w-8 rounded-full h-[6px]"></div>
            <div className="bg-brand w-2 rounded-full h-[6px]"></div>
          </div>
          <h2 className="text-3xl font-extrabold text-heading">
            Зъбни Импланти
          </h2>
          <p className="text-base text-body font-normal">
          Имплантите са титаниеви структури, които се фиксират в костта, играейки роля на корен за нов зъб. Процесът включва поставяне на импланта, остеоинтеграция за около 4 месеца и финално фиксиране на короната или моста. Лечението осигурява пълно възстановяване на функцията и естетиката на усмивката.
          </p>
          <Button type="cta-border" href="/contact">
            Запазете час още сега!
          </Button>
        </div>
      </div>

      <Doctor />

      <div className="page__width flex flex-col items-center justify-center my-20">
        <div className="flex items-center gap-1">
          <div className="bg-brand w-16 rounded-full h-[6px]"></div>
          <div className="bg-brand w-8 rounded-full h-[6px]"></div>
          <div className="bg-brand w-2 rounded-full h-[6px]"></div>
        </div>
        <h2 className="text-3xl font-extrabold text-heading my-8">
          Свържете се с нас
        </h2>
        <div className="flex flex-col lg:flex-row w-full items-center justify-between gap-4">
          <div className="flex items-center justify-center gap-2 w-full lg:w-[30%] p-8 rounded-lg bg-[#ECF6FD]">
            <Icon name="email" className="w-10 h-10" />
            <a
              href="mailto:tomov.dentalclinic@gmail.com"
              target="_blank"
              className="text-heading hover:underline font-bold text-lg"
            >
              tomov.dentalclinic
            </a>
          </div>
          <div className="flex items-center justify-center gap-2 w-full lg:w-[30%] p-8 rounded-lg bg-[#ECF6FD]">
            <Icon name="phone" className="w-10 h-10" />
            <a
              href="tel:088 528 5757"
              target="_blank"
              className="text-heading hover:underline font-bold text-lg"
            >
              088 528 5757
            </a>
          </div>
          <div className="flex items-center justify-center gap-2 w-full lg:w-[30%] p-8 rounded-lg bg-[#ECF6FD]">
            <Icon name="location" className="w-10 h-10" />
            <a
              href="https://maps.app.goo.gl/GWjbmeVQZosEFJNv9"
              target="_blank"
              className="text-heading hover:underline font-bold text-lg"
            >
              ul.Opalchenska 94
            </a>
          </div>
        </div>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2931.8174914281817!2d23.313118100000004!3d42.707585099999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40aa85ed09dbf16d%3A0xcfff98bb12f6872!2sTomov%20Dental%20Clinic!5e0!3m2!1sen!2sbg!4v1718888234195!5m2!1sen!2sbg"
          className="w-full mt-8 rounded-xl"
          height="600"
          style={{ border: 0 }}
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      <div className="w-[90%] lg:w-1/2 mx-auto">
        <ContactForm />
      </div>
      <div className="page__width cta my-20 bg-cover bg-right lg:bg-center flex flex-col lg:items-start justify-center bg-cta-dark lg:bg-cta py-16 px-8 items-center text-center lg:text-start lg:px-16 lg:py-24 rounded-xl">
        <h2 className="text-3xl lg:text-4xl w-full lg:w-1/2 mb-6 text-white font-extrabold">
          Блестящата усмивка е на една ръка разстояние
        </h2>
        <Button href="#">Свържи се с нас</Button>
      </div>
    </>
  );
}
